import { ColumnDef } from '@tanstack/react-table'
import { SortingHeaderButton } from '../../../../components/ui/DataTable/SortingHeaderButton'
import { ApplicationAccessItem, ApplicationAccessRole, TNodeTypeFilter } from '../AppAccessesPageContent'
import { TooltipButton } from '@/components/ui/TooltipButton'
import { IconInformationOutline } from '@icons/IconInformationOutline'
import { Checkbox } from '@/components/shadcn/checkbox'
import { SelectComponent } from '@/components/form-components/SelectComponent'

export function getAppAccessesColumnsV2({
  rolesArray,
  newCheckedMap,
  setCheckedMap,
  nodeTypeFilters,
}: {
  rolesArray: ApplicationAccessRole[]
  newCheckedMap: Map<number, Map<number, boolean>>
  setCheckedMap: (checkedMap: Map<number, Map<number, boolean>>) => void
  nodeTypeFilters: TNodeTypeFilter[]
}): ColumnDef<ApplicationAccessItem>[] {
  const columns: ColumnDef<ApplicationAccessItem>[] = [
    {
      id: 'nodeId',
      accessorFn: (row) => `${row.nodeId} - ${row.nodeDescription}`,
      header: ({ column }) => <SortingHeaderButton column={column}>Node ID</SortingHeaderButton>,
      cell: ({ row }) => (
        <div className="flex flex-col gap-y-1">
          <span className="text-base group-hover:underline">{row.original.nodeId}</span>
          <span className="text-xs font-light leading-[1.1] text-muted-foreground">{row.original.nodeDescription}</span>
        </div>
      ),
      sortingFn: (rowA, rowB) => rowA.original.nodeId.localeCompare(rowB.original.nodeId),
      enableGlobalFilter: true,
      size: 250,
    },
    {
      id: 'nodeType',
      accessorKey: 'nodeType',
      // header: 'Node type',
      header: ({ column }) => (
        <div className="flex items-center gap-x-1.5">
          <span>Node type: </span>
          <SelectComponent
            className="h-6 w-24"
            options={
              ['All', ...nodeTypeFilters.map((x) => ({ label: `${x.nodeType} (${x.count})`, value: x.nodeType }))] as {
                label: string
                value: string
              }[]
            }
            value={(column.getFilterValue() as string) || 'All'}
            onChange={(value) => column.setFilterValue(value === 'All' ? '' : value)}
          />
        </div>
      ),
      cell: ({ cell }) => cell.getValue() as string,
      filterFn: (row, columnId, filterValue) => {
        return row.original.nodeType.toLowerCase() === filterValue.toLowerCase()
      },
      // enableGlobalFilter: true,
    },
  ]

  const dynamicColumns: ColumnDef<ApplicationAccessItem>[] = rolesArray.map((role) => {
    return {
      id: role.roleId.toString(),
      header: () => (
        <div className="flex items-center gap-x-2">
          <div>{role.roleName}</div>
          <TooltipButton tooltip={role.roleDescription}>
            <div>
              <IconInformationOutline className="size-4" />
            </div>
          </TooltipButton>
        </div>
      ),
      cell: ({ row }) => {
        return (
          <div className="pl-5">
            <Checkbox
              checked={newCheckedMap.has(role.roleId) && newCheckedMap.get(role.roleId)?.get(row.original.accessId)}
              onCheckedChange={(checked) => {
                const newChecked = new Map<number, Map<number, boolean>>(newCheckedMap)
                newChecked.get(role.roleId!)?.set(row.original.accessId, checked as boolean)
                setCheckedMap(newChecked)
              }}
            />
          </div>
        )
      },
    }
  })

  return [...columns, ...dynamicColumns]
}
